import React from "react";

const SummarizeIcon = ({ width, height, step = 1 }) => {
  return (
    <>
      {step === 1 && (
        <svg
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2754_5712)">
            <path
              d="M0.75 9C0.75 10.8358 0.849345 12.2597 1.09615 13.3702C1.34105 14.4722 1.72108 15.2191 2.25102 15.749C2.78095 16.2789 3.52774 16.6589 4.62973 16.9039C5.74024 17.1506 7.16424 17.25 9 17.25C10.8358 17.25 12.2597 17.1506 13.3702 16.9039C14.4722 16.6589 15.2191 16.2789 15.749 15.749C16.2789 15.2191 16.6589 14.4722 16.9039 13.3702C17.1506 12.2597 17.25 10.8358 17.25 9C17.25 7.16424 17.1506 5.74024 16.9039 4.62973C16.6589 3.52774 16.2789 2.78095 15.749 2.25102C15.2191 1.72108 14.4722 1.34105 13.3702 1.09615C12.2597 0.849345 10.8358 0.75 9 0.75C7.16424 0.75 5.74024 0.849345 4.62973 1.09615C3.52774 1.34105 2.78095 1.72108 2.25102 2.25102C1.72108 2.78095 1.34105 3.52774 1.09615 4.62973C0.849345 5.74024 0.75 7.16424 0.75 9Z"
              stroke="#00BA9F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.5 6.6001H12.75"
              stroke="#00BA9F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.25 10.3501H12.75"
              stroke="#00BA9F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2754_5712">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
      {step === 2 && (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2754_5980)">
            <path
              d="M0.75 9C0.75 10.8358 0.849345 12.2597 1.09615 13.3702C1.34105 14.4722 1.72108 15.2191 2.25102 15.749C2.78095 16.2789 3.52774 16.6589 4.62973 16.9039C5.74024 17.1506 7.16424 17.25 9 17.25C10.8358 17.25 12.2597 17.1506 13.3702 16.9039C14.4722 16.6589 15.2191 16.2789 15.749 15.749C16.2789 15.2191 16.6589 14.4722 16.9039 13.3702C17.1506 12.2597 17.25 10.8358 17.25 9C17.25 7.16424 17.1506 5.74024 16.9039 4.62973C16.6589 3.52774 16.2789 2.78095 15.749 2.25102C15.2191 1.72108 14.4722 1.34105 13.3702 1.09615C12.2597 0.849345 10.8358 0.75 9 0.75C7.16424 0.75 5.74024 0.849345 4.62973 1.09615C3.52774 1.34105 2.78095 1.72108 2.25102 2.25102C1.72108 2.78095 1.34105 3.52774 1.09615 4.62973C0.849345 5.74024 0.75 7.16424 0.75 9Z"
              stroke="#F4F4F4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.5 6.6001H12.75"
              stroke="#F4F4F4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.25 10.3501H12.75"
              stroke="#F4F4F4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2754_5980">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default SummarizeIcon;
